import { useEffect } from "react"
import { create } from "zustand"

interface PageWrapperScrollStore {
  isScrolled: boolean
  pageWrapperRef: React.RefObject<HTMLDivElement> | null
  setPageWrapperRef: (ref: React.RefObject<HTMLDivElement>) => void
  setIsScrolled: (isScrolled: boolean) => void
}

export const usePageWrapperScrollStore = create<PageWrapperScrollStore>(
  (set) => ({
    isScrolled: false,
    pageWrapperRef: null,
    setPageWrapperRef: (ref) => {
      set({ pageWrapperRef: ref })
    },
    setIsScrolled: (isScrolled) => set({ isScrolled }),
  })
)

export const usePageWrapperScroll = () => {
  const { isScrolled, pageWrapperRef, setPageWrapperRef, setIsScrolled } =
    usePageWrapperScrollStore()

  useEffect(() => {
    const pageWrapper = pageWrapperRef?.current
    if (!pageWrapper) return

    const handleScroll = () => {
      setIsScrolled(pageWrapper.scrollTop > 0)
    }

    pageWrapper.addEventListener("scroll", handleScroll)
    // Initial check
    handleScroll()

    return () => {
      pageWrapper.removeEventListener("scroll", handleScroll)
    }
  }, [pageWrapperRef, setIsScrolled])

  return {
    isScrolled,
    pageWrapperRef,
    setPageWrapperRef,
  }
}
